module.exports = __webpack_public_path__ + "img/IHK_lip.6c5a931c.png";